import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The underwear your girlfriend really wants you to wear",
  "description": "",
  "published": "2008-11-21T00:00:00.000Z",
  "redirect_from": ["/blog/the-underwear-your-girlfriend-really-wants-you-to-wear/swizec/39"],
  "categories": "commentary, funny",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://blog.mozganostroj.com/"
      }}>{`Sparkica`}</a>{` wrote in a recent blogpost `}<a parentName="p" {...{
        "href": "http://blog.mozganostroj.com/2008/11/20/komarka-stolkla-vampirja/"
      }}>{`about a sexy man in minimalistic loose underwear`}</a>{`. Initially I only shrugged it off as interesting, but then it got me thinking about just how often women talk about men's underwear. You'll often hear a passing remark here and there, often they'll even give comments on your underwear flat out - especially if it's "that kind" of relationship.`}</p>
    <p>{`What's most interesting to note here is that women seem to like a lot of different underwear as along as it's on the right body. They like small and loose, like sparkica, or not so small and tight, because it supposedly makes balls look better, not sure, some even like small and tight. But the majority, like a classmate I recently asked, seem to like regular old boxers best.`}</p>
    <p>{`This means of course that if you're a real man you already have what it takes in your trousers - boxers. Sure your body might not quite make the cut or anything, but at least you can't go too wrong with regular boxers, most of them will like it. Strangely enough it's a completely different situation with men. We like thongs and other tight, revealing underwear, whereas girls don't really like wearing such all that much. Most prefer nice comfortable granny pants, at least when they're not in a social situation.`}</p>
    <p>{`But most of all we must notice that women talk about men's `}<em parentName="p">{`underwear`}</em>{` not what's in it. This tells us that they want you to keep it on, so no matter what you're wearing, just remember to keep it on. Nobody likes those pesky one-eyed trouser snakes.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      